/** @format */
'use client';
import UserIcon from '@/app/[locale]/ui/UserIcon';
import { UserMenu } from '@/app/[locale]/ui/UserMenu';
import Popover from 'devextreme-react/popover';

import { useSession } from 'next-auth/react';
import Image from 'next/legacy/image';
import { useCallback, useState } from 'react';

import useProfilePhoto from '@common/application/hooks/useProfilePhoto/useProfilePhoto';

export function UserButton() {
  // Use a callback ref (stored in state) rather than a plain useRef so that attaching the DOM node
  // triggers a re-render. With a plain ref, `target={buttonRef.current!}` can be read once during a
  // render where the node isn't attached yet (or is stale after a remount, e.g. when the [locale]
  // route segment changes and this component remounts) and never gets updated afterwards, leaving
  // the Popover bound to a stale/null target so clicks on the button silently do nothing until a
  // full page refresh forces things to resync.
  const [buttonEl, setButtonEl] = useState<HTMLDivElement | null>(null);
  const buttonRef = useCallback((node: HTMLDivElement | null) => setButtonEl(node), []);
  const { data: session } = useSession();
  const photoUrl = useProfilePhoto();
  const initials = session?.user?.name?.split(' ').map((name) => name[0]);

  return (
    <div>
      <div ref={buttonRef}>
        <UserIcon>{photoUrl ? <Image src={photoUrl} layout="fill" objectFit="cover" alt={'User Avatar'} /> : <span>{initials}</span>}</UserIcon>
      </div>
      {buttonEl && (
        <Popover target={buttonEl} showEvent={'click'} style={{ transformOrigin: 'top center' }}>
          <UserMenu />
        </Popover>
      )}
    </div>
  );
}

export default UserButton;
